import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';

import { AvatarLarge, NamedLink, H2 } from '../../../../components';

import css from '../../ProfilePage.module.css';

const AsideContent = ({ user, isCurrentUser, isBuyerWithSubscription }) => {

  return (
    <div className={css.asideContent}>
      <AvatarLarge className={css.avatar} user={user} disableProfileLink />
      <div className={css.asideContentInfo}>
        {/* <H2 as="h1" className={css.mobileHeading}>
          {displayName ? (
            <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: displayName }} />
          ) : null}
        </H2> */}
        {isCurrentUser ? (
          <>
            <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
              <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
            </NamedLink>
            <NamedLink
              className={css.editLinkDesktop}
              name={isBuyerWithSubscription ? "BrandDetailsPage" : "ProfileSettingsPage"}
            >
              <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
            </NamedLink>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default AsideContent;
